module.exports = __webpack_public_path__ + "assets/img/ico__helmet.6316b93f.png";